import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getIsolates } from '../../redux/samples/selectors';
import { loadIsolates, RESET_LOAD_ISOLATES } from '../../redux/samples/actions';
import { getCurrOrg } from '../../redux/orgs/selectors';
import { action } from '../../redux/helpers';

export const useIsolates = (sampleId) => {
  const dispatch = useDispatch();
  const firstLoad = useRef(false);
  const [resetCalled, setResetCalled] = useState(false);
  const currOrg = useSelector(getCurrOrg);
  const isolates = useSelector(getIsolates);
  const currPage = useSelector((s) => s.samples.currIsolatesPage);
  const hasMore = useSelector((s) => s.samples.hasMoreIsolates);
  const loading = useSelector((s) => s.samples.loadIsolatesPending);

  useEffect(() => {
    if (loading) {
      firstLoad.current = true;
    }
  }, [loading]);

  const noResults = useMemo(() => {
    return (
      firstLoad.current &&
      !loading &&
      !hasMore &&
      _.get(isolates, 'length', 0) == 0
    );
  }, [loading, hasMore, isolates]);

  // Reset list on mount
  useEffect(() => {
    dispatch(action(RESET_LOAD_ISOLATES));
    setResetCalled(true);
  }, []);

  const loadMore = useCallback(() => {
    dispatch(loadIsolates(sampleId, currPage + 1));
  }, [currPage, currOrg, sampleId]);

  return {
    // Ignore redux list until first load
    isolates: firstLoad.current ? isolates : [],
    hasMore: resetCalled && hasMore,
    loading,
    noResults,
    loadMore,
  };
};
